<template>
    <div class="user-statistice">
        <el-row :gutter='20'>
            <el-col :span='20'>
                <div class="title-box"><span class="m-title">个人实际流量使用分布</span></div>
                <div class="chose-item">
                     <el-form inline style="height: auto;">
                        <el-form-item label="条件选择:">
						</el-form-item>
                            <el-form-item>
                                <el-date-picker v-model="form1.year" type="year" placeholder="选择年份" value-format='yyyy' style="width:100px"></el-date-picker>
                            </el-form-item>
                             <el-form-item>
                                <el-select v-model="form1.productType" clearable filterable placeholder="产品类型" style="width:100px" @visible-change="changeList1">
                                   <!-- <el-option label="其他" value="0"></el-option >
                                    <el-option label="大河卡" value="1"></el-option>
                                    <el-option label="手表卡" value="2"></el-option>
                                    <el-option label="大流量卡" value="3"></el-option> -->
                      <el-option v-for="(item,index) in w_PRODUCT_" :label="item.groupName" :value="item.dictValue" :key="index"></el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item>
                                <el-select v-model="form1.accountIds" multiple collapse-tags clearable filterable placeholder="请选择运营商" style="width:150px" @visible-change="changeList1">
                                    <el-option v-for="(item,index) in accountList1" :key="index" :label="item.accountName" :value="item.accountId">
                                    </el-option>
                                </el-select>
							</el-form-item>

                            <el-form-item>
                                <el-select v-model="form1.agentIds" multiple collapse-tags clearable filterable placeholder="代理商" style="width:150px" @visible-change="changeList1">
                                    <el-option v-for="(item,index) in agentIdList1" :key="index" :label="item.agentName" :value="item.agentId"></el-option>
                                </el-select>
                            </el-form-item>
                            
                        
                            <el-form-item>
                                <el-select v-model="form1.toType" clearable filterable placeholder="业务类型" style="width:100px" @visible-change="changeList1">
                                    <el-option v-for="(item,index) in typeList1" :key="index" :label="item.name" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item>
                                <el-select v-model="form1.mealIds" multiple collapse-tags clearable filterable placeholder="套餐"  style="width:150px">
                                    <el-option v-for="(item,index) in mealList1" :key="index" :label="item.mealName" :value="item.mealId">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="低阀值(G)">
                                <el-input v-model="form1.minFlow1" placeholder="最小值" style="width:80px"></el-input>
                                <span>--</span>
                                <el-input v-model="form1.maxFlow1" placeholder="最大值" style="width:80px"></el-input>
                            </el-form-item>
                            <el-form-item label="中阀值(G)">
                                <el-input v-model="form1.minFlow2" placeholder="最小值" style="width:80px"></el-input>
                                <span>--</span>
                                <el-input v-model="form1.maxFlow2" placeholder="最大值" style="width:80px"></el-input>
                            </el-form-item>
                            <el-form-item label="高阀值(G)">
                                <el-input v-model="form1.minFlow3" placeholder="最小值" style="width:80px"></el-input>
                                <span>--</span>
                                <el-input v-model="form1.maxFlow3" placeholder="最大值" style="width:80px"></el-input>
                            </el-form-item>

                            <el-form-item>
                                <el-button @click="showTable1" size="mini" class="themed-button" type="danger">确 定</el-button>
                            </el-form-item>


                     </el-form>
                </div>
                <div ref='demo1' style="height:500px;background-color: #fff;"></div>
            </el-col>

            <el-col :span='4'>

            </el-col>
        </el-row>
    </div>
</template>

<script>
import echarts from "echarts"
import {getAccountList,useFlowRate,geMealList,searchParamCheck} from "@/api/operationalStatistics/operationalStatistics.js"
import dictGroup from '@/mixins/dictGroup.js'

export default {
    mixins:[dictGroup],
    data(){
        return{
            form1:{
                year:'',
                agentIds:[],
                accountIds:[],
                toType:'',
                productType:'',
                mealIds:[],
                minFlow1:'',
                maxFlow1:'',
                minFlow2:'',
                maxFlow2:'',
                minFlow3:'',
                maxFlow3:'',
            },
            agentIdList1:[],
            accountList1:[],
            typeList1:[],
            mealList1:[],

            userRechargerMonthAVG1:[],
            userRechargerMonthAVG2:[],
            userRechargerMonthAVG3:[],

            barChart1:'',

        }
    },
    mounted() {
			window.onresize = () => {
				return (() => {
					this.barChart1.resize()
				})()
			}
        },
    watch:{
        'form1.productType'	:function(val){
                this.form1.agentIds = []
                this.form1.accountIds = []
                this.form1.mealIds = []
                this.form1.toType = ''
            },
        'form1.accountIds'	:function(val){
                this.form1.agentIds = []
                this.form1.toType = ''
                this.form1.mealIds = []
            },
        'form1.agentIds':function(val){
                this.form1.toType = ''
                this.form1.mealIds = []
            },
        'form1.toType':function(val){
                this.form1.mealIds = []
            },
    },
    created(){
        this.$nextTick(function(){
            this.initChart1()
        })
    },
    methods:{
        changeList1(e){
            if(e){
                return false
            }else{
                searchParamCheck(this.form1).then(res=>{
                    this.agentIdList1 = res.agents?res.agents:[]
                    this.accountList1 = res.account?res.account:[]
                    this.typeList1 = res.toTypes?res.toTypes:[]
                    this.mealList1 = res.meals
                })
            }

        },
        
        showTable1(){
            useFlowRate(this.form1).then(res=>{
                this.userRechargerMonthAVG1 = res.userRechargerMonthAVG1
                this.userRechargerMonthAVG2 = res.userRechargerMonthAVG2
                this.userRechargerMonthAVG3 = res.userRechargerMonthAVG3
                this.initChart1()
           })
        },

        initChart1(){
            let dom = this.$refs.demo1
            let myChart = echarts.init(dom)
            this.barChart1 = myChart
            const option = {
                title:[
                    {
                        top:'30%',
                        left:10,
                        subtextStyle: {
                            align: 'left',
                            color: '#0000ff',
                            fontSize: 12,
                        },
                        subtext: '比\n例'//   \n换行
                    },

                ],

                legend: {
                    data: [
                        {name: '低流量比例'},
                        {name: '中流量比例'},
                        {name: '高流量比例'}
                    ],
                    textStyle: {
                        color: '#0000ff',
                        fontSize: 11
                    },
                    y: 'bottom',
                    x: 'center',
                },

                xAxis:{
                   data:['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']
                },

                yAxis:{
                   type:'value',
                   name:'单位（*100%）'
                },

               dataZoom: [
                {  
                    type: 'inside', // 这个 dataZoom 组件是 inside 型 dataZoom 组件
                    start: 0,      // 左边在 % 的位置。
                    end: 100         // 右边在 % 的位置。
                }
                ],

                series:[
                   {
                       name:'低流量比例',
                       type:'bar',
                       data:this.userRechargerMonthAVG1,
                   },
                   {
                       name:'中流量比例',
                       type:'bar',
                       data:this.userRechargerMonthAVG2,
                   },
                    {
                       name:'高流量比例',
                       type:'bar',
                       data:this.userRechargerMonthAVG3,
                   },
               ],

               tooltip : {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                }

            }

            myChart.setOption(option)
        },

    }
}
</script>

<style>
 .user-statistice   .el-form-item--small.el-form-item{
        margin-bottom:0
    }

    .el-row {
        margin-bottom: 20px;   
    }
</style>